import { render } from "./LocaleChanger.vue?vue&type=template&id=4b033b56"
import script from "./LocaleChanger.vue?vue&type=script&lang=js"
export * from "./LocaleChanger.vue?vue&type=script&lang=js"

import "./LocaleChanger.vue?vue&type=style&index=0&id=4b033b56&lang=css"

import exportComponent from "/var/www/vote.gikit.ru/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__